import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { StorageKeys } from 'src/app/model/enums/storage-keys';
import { AuthorizationService } from 'src/app/services/authorization/authorization.service';
import { StorageService } from '../storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationGuardService 
{
    private readonly authorizationService: AuthorizationService;
    private readonly router: Router;
    private readonly storageService: StorageService;

    public constructor(authorizationService: AuthorizationService, router: Router, storageService: StorageService)
    {
        this.authorizationService = authorizationService;
        this.router = router;
        this.storageService = storageService;
    }

    public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean>
    {
        const authorized = await this.authorizationService.isAuthorized();
        if (!authorized)
        {
            this.storageService.setItem(StorageKeys.LoginReferrer, state.url, false);
            this.router.navigate(['/login']);
        }

        return authorized;
    }
}
